import React, { useState } from "react";

import AdminNavbar from "components/Navbars/AdminNavbar";
import Footer2 from "components/Footers/Footer2";

import spoorthiblack from "assets/img/spoorthiblack.jpeg";
import ashwiniblack from "assets/img/ashwiniblack.jpeg";
import bindublack from "assets/img/bindublack.jpeg";
import bannerr from "assets/img/bannerr.png";

import shruthiblack from "assets/img/shruthiblack.jpeg";

import shape from "assets/img/new/shape.png";
import physicalicon from "assets/img/new/physicalicon.png";
import innovation from "assets/img/new/innovation.jpg";
import innovationicon from "assets/img/new/innovationicon.png";
import painticon from "assets/img/new/painticon.png";
import childalphabet from "assets/img/new/childalphabet.jpg";
import alphabeticon from "assets/img/new/alphabeticon.png";
import childendless from "assets/img/new/childendless.jpg";
import endlessicon from "assets/img/new/endlessicon.png";
import childgarden from "assets/img/new/childgarden.jpg";
import environmenticon from "assets/img/new/environmenticon.png";
import childdance from "assets/img/new/childdance.jpg";
import danceicon from "assets/img/new/danceicon.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";
import socialemotional from "assets/img/socialemotional.jpg";
import physicalagilityy from "assets/img/physicalagilityy.jpg";
import visualarts from "assets/img/new/visualarts.jpg";
import entrepreneurialfoundation from "assets/img/EntrepreneurialFoundation.webp";
import technologyy from "assets/img/technologyy.webp";
import modality from "assets/img/modality.webp";
import playwithpurpose from "assets/img/playwithpurpose.webp";
import nature from "assets/img/nature.webp";
import skill from "assets/img/skill.webp";

import freedom from "assets/img/Freedom.webp";
import linebgg from "assets/img/new/linebgg.png";
import bgg from "assets/img/bgg.png";
import clouds from "assets/img/clouds.webp";
import balloon from "assets/img/balloon.png";
import bfly1 from "assets/img/bfly1.webp";
import girlll from "assets/img/girlll.png";
import sunitha from "assets/img/sunitha.jpg";
import { Link } from "react-router-dom";
import ashwiniimg from "assets/img/ashwiniimg.png";
import stella from "assets/img/stella.png";
import Popup from "./Popup";

export default function Homepage1() {
  document.addEventListener("DOMContentLoaded", () => {
    const gridItems = document.querySelectorAll(".grid-item");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate"); // Add the animation class when visible
          } else {
            entry.target.classList.remove("animate"); // Remove class if it goes out of view
          }
        });
      },
      { threshold: 0.1 }
    ); // Trigger when 10% of the item is visible

    gridItems.forEach((item) => observer.observe(item));
  });

  const [showPopup, setShowPopup] = useState(false);

  const [buttonPopup, setButtonPopup] = useState(false);
  const [buttonPopup1, setButtonPopup1] = useState(false);
  const [buttonPopup2, setButtonPopup2] = useState(false);
  const [buttonPopup3, setButtonPopup3] = useState(false);

  document.addEventListener("DOMContentLoaded", () => {
    const gridItems = document.querySelectorAll(".grid-item");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate"); // Add the animation class when visible
          } else {
            entry.target.classList.remove("animate"); // Remove class if it goes out of view
          }
        });
      },
      { threshold: 0.1 }
    ); // Trigger when 10% of the item is visible

    gridItems.forEach((item) => observer.observe(item));
  });

  return (
    <section className="parkinsans">
       <Popup/>
      <AdminNavbar />

      {/* banner desktop */}
      <section>
        <div className="flex relative sticky top-0 xl:pt-4 parkinsans xl:block lg:block md:block sm:hidden hidden">
          <div
            className="xl:h-screen lg:h-screen md:h-590"
            style={{
              backgroundImage: `url(${bgg})`,
              backgroundPosition: "center center",
              backgroundRepeat: "repeat",
              backgroundSize: "55% auto",
            }}
          >
            <div className="">
              <div className="grid grid-cols-2">
                <div className="">
                  <div className="flex justify-end  relative">
                    <div className="absolute ">
                      <img
                        className="xl:w-44 lg:w-40 md:w-32 w-20 xl:pt-12 lg:pt-16 md:pt-16"
                        src={bfly1}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className=" flex justify-start top-0 absolute right-0 ">
                    <img
                      className="xl:w-44 lg:w-40 md:w-32 w-20 xl:pt-0 lg:pt-0 md:pt-8"
                      src={clouds}
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <div className=" container mx-auto  xl:pt-0">
                <div className="grid md:grid-cols-2">
                  <div className="xl:pt-36 lg:pt-52 md:pt-32">
                    <div className="texthome xl:ml-0 lg:ml-4 md:ml-4">
                      {/* <h1 className="xl:text-2xl md:text-xl text-peach  bubblegum">
                        Kindergarten Magic
                      </h1> */}
                      <h1 className="xl:text-6xl md:text-4xl text-black font-bold xl:mt-4 md:mt-4">
                        India’s First
                        <h1 className="xl:text-6xl md:text-4xl font-bold xl:mt-4">
                          Entrepreneurial
                        </h1>
                        <h1 className="xl:text-6xl md:text-4xl font-bold xl:mt-4">
                          Preschool
                        </h1>
                      </h1>
                      <h1 className="xl:text-lg lg:text-lg md:text-sm text-black  font-semibold xl:mt-4 md:mt-4">
                        Little learners today, future leaders tomorrow
                      </h1>
                      <p className="xl:text-base lg:text-base md:text-sm text-black">
                        shaped by the Antah:Prerana - Way of learning!
                      </p>

                      <div className="xl:mt-4 lg:mt-4 mt-4">
                        <div className="flex xl:pb-6 lg:pb-4 pb-4">
                          <div className="gird grid-cols-1 xl:mt-6 lg:mt-4 xl:mt-6 md:mt-4">
                            <div className="xl:px-1 lg:px-1 xl:py-3 lg:py-2 md:px-1 md:py-2 px-1 py-2 bg01"></div>
                            <div className="xl:px-1 lg:px-1 xl:py-3 lg:py-2 md:px-1 md:py-2 px-1 py-2 bg02"></div>
                            <div className="xl:px-1 lg:px-1 xl:py-3 lg:py-2 md:px-1 md:py-2 px-1 py-2 bg03"></div>
                          </div>
                          <button
                            className="border-0 focus:outline-none text-base  text-black font-bold bg-white xl:px-8 xl:py-0 lg:px-6 lg:mt-4 xl:mt-6 px-4 md:mt-4"
                            style={{ background: "#F4CDBE" }}
                          >
                            <a href="/enroll-now">Admission</a>
                          </button>

                          <div className="gird grid-cols-1 xl:mt-6 md:mt-4 xl:ml-8 lg:mt-4 lg:ml-6 ml-4">
                            <div className="xl:px-1 xl:py-3 lg:px-1 lg:py-2 md:px-1 md:py-2 px-1 py-2 bg04"></div>
                            <div className="xl:px-1 xl:py-3 lg:px-1 lg:py-2 md:px-1 md:py-2 px-1 py-2 bg05"></div>
                            <div className="xl:px-1 xl:py-3 lg:px-1 lg:py-2 md:px-1 md:py-2 px-1 py-2 bg06"></div>
                          </div>
                          <button
                            className="border-0 focus:outline-none  text-base  text-black font-bold bg-white xl:px-4 xl:py-0 lg:px-6 lg:mt-4 xl:mt-6 md:mt-4 px-2"
                            style={{ background: "#B8C8BE" }}
                          >
                            <a href="/become-partner">Become a Partner</a>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="xl:block lg:block md:hidden sm:hidden hidden">
                    <div className="absolute flex justify-center items-end bottom-0">
                      <img
                        src={girlll}
                        alt="Kids Playing"
                        className="xl:w-8/12 lg:w-10/12 xl:pt-8 "
                      />
                    </div>
                  </div>

                  {/* tabview */}
                  <div className=" xl:hidden lg:hidden sm:hidden md:block hidden">
                    <div class=" flex justify-end pt-36">
                      <img
                        src={girlll}
                        alt="Kids Playing"
                        className=" md:w-12/12  "
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div>
                <div className="xl:block lg:block md:hidden sm:hidden hidden">
                  <img
                    src={balloon}
                    alt="Kids Playing"
                    className="xl:w-24 lg:w-32 w-20 bottom-0 left-0 absolute xl:pt-2"
                  />
                </div>
                {/* tabview 
                <div className="xl:hidden lg:hidden md:block sm:hidden hidden">
                  <img
                    src={balloon}
                    alt="Kids Playing"
                    className="w-20 -mt-24 "
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      

      {/* banner mobile */}
      <section className="xl:hidden lg:hidden md:hidden sm:block block ">
        <div className="flex relative sticky top-0 pt-12">
          <div
            className=""
            style={{
              backgroundImage: `url(${bgg})`,
              backgroundSize: "cover", // Ensure the background covers the container
              backgroundPosition: "center", // Center the background
              width: "100%",
            }}
          >
            <div>
              <div className="flex justify-between">
                <div>
                  <div>
                    <img className="w-32 " src={bfly1} alt="" />
                  </div>
                </div>
                <div>
                  <div className=" absolute right-0">
                    <img className="w-32" src={clouds} alt="" />
                  </div>
                </div>
              </div>

              <div className="container mx-auto px-4 pt-12">
                {/* <h1 className="text-xl text-peach  bubblegum">
                  Kindergarten Magic
                </h1> */}
                <h1 className="text-4xl text-black font-bold mt-2">
                  India’s First
                  <h1 className="text-4xl font-bold mt-2">Entrepreneurial</h1>
                  <h1 className="text-4xl font-bold mt-2">Preschool</h1>
                </h1>
                <h1 className="text-sm text-black  font-semibold mt-2">
                  Little learners today, future leaders tomorrow
                </h1>
                <p className="text-sm text-black">
                  shaped by the Antah:Prerana - Way of learning!
                </p>

                <div className=" mt-4">
                  <div className="flex  pb-4">
                    <div className="grid grid-cols-1 ">
                      <div className=" px-1 py-1 bg01"></div>
                      <div className=" px-1 py-1 bg02"></div>
                      <div className=" px-1 py-1 bg03"></div>
                    </div>
                    <button
                      className="border-0 focus:outline-none text-base  text-black font-bold bg-white  px-4 "
                      style={{ background: "#F4CDBE" }}
                    >
                      <a href="/enroll-now">Admission</a>
                    </button>

                    <div className="grid grid-cols-1 ml-4">
                      <div className=" px-1 py-1 bg04"></div>
                      <div className=" px-1 py-1 bg05"></div>
                      <div className=" px-1 py-1 bg06"></div>
                    </div>
                    <button
                      className="border-0 focus:outline-none  text-base  text-black font-bold bg-white  px-2 py-2"
                      style={{ background: "#B8C8BE" }}
                    >
                      <a href="/become-partner">Become a Partner</a>
                    </button>
                  </div>
                </div>
                {/* <div className="flex justify-end">
                  <img
                    src={balloon}
                    alt="Kids Playing"
                    className="w-16"
                  />
                </div> */}
              </div>

              <div class="flex justify-center bottom-0">
                <img src={girlll} alt="Kids Playing" className="w-10/12" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-neutral-200 xl:pt-14 lg:pt-16 md:pt-16 pt-12 ">
        <div className="container mx-auto">
          {/* <h3 class="text-peach font-semibold text-center uppercase xl:text-base  bubblegum">
            Why Choose Us{" "}
          </h3> */}
          <h2 class="xl:text-5xl text-black lg:text-4xl md:text-3xl text-2xl  text-center font-bold">
            A New Age Preschool
          </h2>
          <p className="text-center xl:text-lg xl:mt-3 lg:mt-2 justify-center mx-auto xl:block lg:block md:hidden sm:hidden hidden">
            Junior Toes International Preschool is dedicated to shaping the
            future leaders of tomorrow.<br></br> Our innovative early childhood
            education model is built on the research-based Curriculum designed by Award Winning Educationists, <br></br>The Antah Prerana Way of Learning, designed to
            inspire creativity, critical thinking and leadership in young minds.
          </p>
          {/* tab and mobile view */}
          <p className="text-center text-base mt-2 justify-center mx-auto xl:hidden lg:hidden md:block sm:block block px-8">
            Junior Toes International Preschool is dedicated to shaping the
            future leaders of tomorrow. Our innovative early childhood education
            model is built on the research-based Curriculum designed by Award Winning Educationists The
            Antah Prerana Way of Learning, designed to inspire creativity,
            critical thinking, and leadership in young minds
          </p>
          <div className="xl:w-11/12 justify-center mx-auto xl:mt-8 md:mt-8 md:pb-16  xl:pb-12 lg:mt-8 lg:pb-16 xl:px-0 lg:px-4 px-4 pb-12 mt-8">
            <Swiper
              slidesPerView={3} // Default for larger screens
              spaceBetween={30}
              centeredSlides={false}
              loop={true}
              autoplay={{
                delay: 4600, // Adjust delay (100ms might be too fast for testing)
                disableOnInteraction: false,
              }}
              breakpoints={{
                1280: {
                  slidesPerView: 3, // Show 3 slides for larger devices
                  slidesPerGroup: 1,
                },
                1024: {
                  slidesPerView: 3, // Show 2 slides for tablets and small screens
                  slidesPerGroup: 1,
                },

                768: {
                  slidesPerView: 2, // Show 1 slide for mobile screens
                  slidesPerGroup: 1,
                },

                400: {
                  slidesPerView: 1, // Show 1 slide for mobile screens
                  slidesPerGroup: 1,
                },

                360: {
                  slidesPerView: 1, // Show 1 slide for mobile screens
                  slidesPerGroup: 1,
                },
              }}
              modules={[Autoplay]} // Ensure the module is included here
              className="mySwiper"
            >
              <SwiperSlide>
                <div className="">
                  <div className="">
                    <img src={innovation} alt="" className="css1 " />
                  </div>
                  <div className="css">
                    <div className=" ">
                      <div
                        className="p-2 flex justify-center  mx-auto"
                        style={{
                          width: "80%",
                          backgroundImage: `url(${shape})`,
                          backgroundPosition: "center ",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "contain",
                        }}
                      >
                        <img
                          src={innovationicon}
                          alt=""
                          className="xl:w-14 lg:w-14 md:w-12 w-12 "
                        ></img>
                      </div>
                      <h5 className="xl:text-base lg:text-base  text-base lg:mt-2 text-black  text-center font-bold  xl:mt-3 mt-2">
                        Innovation
                      </h5>
                      <p className="xl:text-base lg:text-base text-base md:text-sm text-center">
                        Junior Toes discovering new wonders
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="">
                    <img src={childalphabet} alt="" className="css1 " />
                  </div>
                  <div className="css">
                    <div className=" ">
                      <div
                        className="p-2 flex justify-center  mx-auto"
                        style={{
                          width: "80%",
                          backgroundImage: `url(${shape})`,
                          backgroundPosition: "center ",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "contain",
                        }}
                      >
                        <img
                          src={alphabeticon}
                          alt=""
                          className="xl:w-14 lg:w-14 md:w-12 w-12 "
                        ></img>
                      </div>
                      <h5 className="xl:text-base lg:text-base text-base lg:mt-2 text-black  text-center font-bold  xl:mt-3 mt-2">
                        Communication
                      </h5>
                      <p className="xl:text-base lg:text-base text-base md:text-sm text-center">
                        Junior Toes Gathering Knowledge one word at a time
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="">
                    <img src={socialemotional} alt="" className="css1 " />
                  </div>
                  <div className="css">
                    <div className=" ">
                      <div
                        className="p-4 flex justify-center  mx-auto"
                        style={{
                          width: "80%",
                          backgroundImage: `url(${shape})`,
                          backgroundPosition: "center ",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "contain",
                        }}
                      >
                        <img
                          src={painticon}
                          alt=""
                          className="xl:w-14 lg:w-14 md:w-12 w-12 "
                        ></img>
                      </div>
                      <h5 className="xl:text-base lg:text-base text-base lg:mt-2 text-black  text-center font-bold  xl:mt-3 mt-2">
                        Socio Emotional
                      </h5>
                      <p className="xl:text-base lg:text-base md:text-sm text-base text-center">
                        Junior Toes finding harmony, one pose at a time
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="">
                    <img src={childendless} alt="" className="css1 " />
                  </div>
                  <div className="css">
                    <div className=" ">
                      <div
                        className="p-2 flex justify-center  mx-auto"
                        style={{
                          width: "80%",
                          backgroundImage: `url(${shape})`,
                          backgroundPosition: "center ",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "contain",
                        }}
                      >
                        <img
                          src={endlessicon}
                          alt=""
                          className="xl:w-14 lg:w-14 md:w-12 w-12 "
                        ></img>
                      </div>
                      <h5 className="xl:text-base lg:text-base text-base lg:mt-2 text-black  text-center font-bold  xl:mt-3 mt-2">
                        Numeracy
                      </h5>
                      <p className="xl:text-base text-center text-base md:text-sm">
                        Junior Toes Counting Endless Posibiliites
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="">
                    <img src={childgarden} alt="" className="css1 " />
                  </div>
                  <div className="css">
                    <div className=" ">
                      <div
                        className="p-2 flex justify-center  mx-auto"
                        style={{
                          width: "80%",
                          backgroundImage: `url(${shape})`,
                          backgroundPosition: "center ",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "contain",
                        }}
                      >
                        <img
                          src={environmenticon}
                          alt=""
                          className="xl:w-14 lg:w-14 md:w-12 w-12"
                        ></img>
                      </div>
                      <h5 className="xl:text-base lg:text-base text-base lg:mt-2 text-black  text-center font-bold  xl:mt-3 mt-2">
                        Environmental Sensitivity
                      </h5>
                      <p className="xl:text-base text-base lg:text-base md:text-sm text-center">
                        Junior Toes Taking Gentle Steps towards a green world
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="">
                    <img src={physicalagilityy} alt="" className="css1 " />
                  </div>
                  <div className="css">
                    <div className=" ">
                      <div
                        className="p-2 flex justify-center  mx-auto"
                        style={{
                          width: "80%",
                          backgroundImage: `url(${shape})`,
                          backgroundPosition: "center ",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "contain",
                        }}
                      >
                        <img
                          src={physicalicon}
                          alt=""
                          className="xl:w-14 lg:w-14 md:w-12 w-12 "
                        ></img>
                      </div>
                      <h5 className="xl:text-base lg:text-base text-base lg:mt-2 text-black  text-center font-bold  xl:mt-3 mt-2">
                        Physical Agility
                      </h5>
                      <p className="xl:text-base text-base lg:text-base md:text-sm text-center">
                        Junior Toes Mastering big challenges
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="">
                    <img src={visualarts} alt="" className="css1 " />
                  </div>
                  <div className="css">
                    <div className=" ">
                      <div
                        className="p-2 flex justify-center  mx-auto"
                        style={{
                          width: "80%",
                          backgroundImage: `url(${shape})`,
                          backgroundPosition: "center ",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "contain",
                        }}
                      >
                        <img
                          src={painticon}
                          alt=""
                          className="xl:w-14 lg:w-14 md:w-12 w-12"
                        ></img>
                      </div>
                      <h5 className="xl:text-base lg:text-base text-base lg:mt-2 text-black  text-center font-bold  xl:mt-3 mt-2">
                        Visual Arts
                      </h5>
                      <p className="xl:text-base lg:text-base md:text-sm text-center text-base">
                        Junior Toes Painting grand imaginations
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="">
                  <div className="">
                    <img src={childdance} alt="" className="css1 " />
                  </div>
                  <div className="css">
                    <div className=" ">
                      <div
                        className="p-2 flex justify-center  mx-auto"
                        style={{
                          width: "80%",
                          backgroundImage: `url(${shape})`,
                          backgroundPosition: "center ",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "contain",
                        }}
                      >
                        <img
                          src={danceicon}
                          alt=""
                          className="xl:w-14 lg:w-14 md:w-12 w-12 "
                        ></img>
                      </div>
                      <h5 className="xl:text-base lg:text-base text-base lg:mt-2 text-black  text-center font-bold  xl:mt-3 mt-2">
                        Performing Arts
                      </h5>
                      <p className="xl:text-base lg:text-base md:text-sm text-center text-base">
                        Junior Toes moving<br></br> in rhythm
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>

      <section className="xl:mt-14 container mx-auto lg:mt-16 md:mt-16 mt-12 xl:px-0 px-4">
        <h2 class="xl:text-5xl text-black lg:text-4xl md:text-3xl text-2xl text-center font-bold">
          Why Junior Toes
        </h2>
        <p className="mb-6 text-center xl:text-base lg:text-base md:text-base text-sm lg:mt-2 xl:mt-1 xl:w-7/12 justify-center mx-auto md:mt-4 mt-2">
          "At Junior Toes, little feet walk the path of big dreams with
          confidence and creativity."
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 xl:gap-6 xl:mt-12 gap-4 lg:mt-12 mt-8">
          <div className="rounded-xl " style={{ backgroundColor: "#9dd5e2" }}>
            <div
              style={{
                backgroundImage: `url(${linebgg})`,
                backgroundSize: "contain",
                backgroundPosition: "center ",
                width: "auto",
              }}
            >
              <div className="xl:p-4 lg:p-4 md:p-4 p-4">
                <div className=" flex justify-between items-end">
                  <div className="">
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Entrepreneurial
                    </h1>
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl pt-2 font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Foundation
                    </h1>
                  </div>
                  <div className="bottom-0">
                    <a href="/foundation#entrepreneurial-section">
                      <div className="bg-white w-12 h-12 mx-auto items-center justify-center flex rounded-full cursor-pointer">
                        <i className="las la-arrow-right font-bold"></i>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="xl:mt-6 lg:mt-4 mt-4">
                  <img
                    className="rounded-xl"
                    src={entrepreneurialfoundation}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-xl " style={{ backgroundColor: "#d8d0c5" }}>
            <div
              style={{
                backgroundImage: `url(${linebgg})`,
                backgroundSize: "contain",
                backgroundPosition: "center ",
                width: "auto",
              }}
            >
              <div className="xl:p-4 lg:p-4 md:p-4 p-4">
                <div className=" flex justify-between items-end">
                  <div className="">
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl  font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Technology of
                    </h1>
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Consciousness
                    </h1>
                  </div>
                  <div className="bottom-0">
                    <a href="/foundation#technology-of-consciousness-section">
                      <div className="bg-white w-12 h-12 mx-auto items-center justify-center flex rounded-full cursor-pointer">
                        <i className="las la-arrow-right font-bold"></i>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="xl:mt-6 lg:mt-4 mt-4">
                  <img className="rounded-xl" src={technologyy} alt="" />
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-xl " style={{ backgroundColor: "#f8b4a9" }}>
            <div
              style={{
                backgroundImage: `url(${linebgg})`,
                backgroundSize: "contain",
                backgroundPosition: "center ",
                width: "auto",
              }}
            >
              <div className="xl:p-4 lg:p-4 md:p-4 p-4">
                <div className=" flex justify-between items-end">
                  <div className="">
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl  font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Modality of
                    </h1>
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl  font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Consciousness
                    </h1>
                  </div>
                  <div className="bottom-0">
                    <a href="/foundation#modality-of-consciousness-section">
                      <div className="bg-white w-12 h-12 mx-auto items-center justify-center flex rounded-full cursor-pointer">
                        <i className="las la-arrow-right font-bold"></i>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="xl:mt-6 lg:mt-4 mt-4">
                  <img className="rounded-xl" src={modality} alt="" />
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-xl " style={{ backgroundColor: "#fff5c4" }}>
            <div
              style={{
                backgroundImage: `url(${linebgg})`,
                backgroundSize: "contain",
                backgroundPosition: "center ",
                width: "auto",
              }}
            >
              <div className="xl:p-4 lg:p-4 md:p-4 p-4">
                <div className=" flex justify-between items-end">
                  <div className="">
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Play With
                    </h1>
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl  font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Purpose
                    </h1>
                  </div>
                  <div className="bottom-0">
                    <a href="/foundation#play-with-purpose-section">
                      <div className="bg-white w-12 h-12 mx-auto items-center justify-center flex rounded-full cursor-pointer">
                        <i className="las la-arrow-right font-bold"></i>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="xl:mt-6 lg:mt-4 mt-4">
                  <img className="rounded-xl" src={playwithpurpose} alt="" />
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-xl " style={{ backgroundColor: "#6ab4b3" }}>
            <div
              style={{
                backgroundImage: `url(${linebgg})`,
                backgroundSize: "contain",
                backgroundPosition: "center ",
                width: "auto",
              }}
            >
              <div className="xl:p-4 lg:p-4 md:p-4 p-4">
                <div className=" flex justify-between items-end">
                  <div className="">
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Nature and
                    </h1>
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl  font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Environment Focus
                    </h1>
                  </div>
                  <div className="bottom-0">
                    <a href="/foundation#nature-and-environment-section">
                      <div className="bg-white w-12 h-12 mx-auto items-center justify-center flex rounded-full cursor-pointer">
                        <i className="las la-arrow-right font-bold"></i>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="xl:mt-6 lg:mt-4 mt-4">
                  <img className="rounded-xl" src={nature} alt="" />
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-xl " style={{ backgroundColor: "#f1e1c8" }}>
            <div
              style={{
                backgroundImage: `url(${linebgg})`,
                backgroundSize: "contain",
                backgroundPosition: "center ",
                width: "auto",
              }}
            >
              <div className="xl:p-4 lg:p-4 md:p-4 p-4">
                <div className=" flex justify-between items-end">
                  <div className="">
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Skill-Based
                    </h1>
                    <h1 className="xl:text-3xl lg:text-2xl  md:text-xl text-xl font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Learning
                    </h1>
                  </div>
                  <div className="bottom-0">
                    <a href="/foundation#skill-based-learning-section">
                      <div className="bg-white w-12 h-12 mx-auto items-center justify-center flex rounded-full cursor-pointer">
                        <i className="las la-arrow-right font-bold"></i>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="xl:mt-6 lg:mt-4 mt-4">
                  <img className="rounded-xl" src={skill} alt="" />
                </div>
              </div>
            </div>
          </div>

          <div></div>

          <div className="rounded-xl " style={{ backgroundColor: "#dadada" }}>
            <div
              style={{
                backgroundImage: `url(${linebgg})`,
                backgroundSize: "contain",
                backgroundPosition: "center ",
                width: "auto",
              }}
            >
              <div className="xl:p-4 lg:p-4 md:p-4 p-4">
                <div className=" flex justify-between items-end">
                  <div className="">
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Freedom to
                    </h1>
                    <h1 className="xl:text-3xl lg:text-2xl md:text-xl text-xl font-bold text-black xl:pt-2 lg:pt-2 pt-0">
                      Grow
                    </h1>
                  </div>
                  <div className="bottom-0">
                    <a href="/foundation#freedom-to-grow-section">
                      <div className="bg-white w-12 h-12 mx-auto items-center justify-center flex rounded-full cursor-pointer">
                        <i className="las la-arrow-right font-bold"></i>
                      </div>
                    </a>
                  </div>
                </div>
                <div className="xl:mt-6 lg:mt-4 mt-4">
                  <img className="rounded-xl" src={freedom} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="xl:-ml-4 parkinsans lg:-ml-0 xl:px-0 lg:px-4 md:px-4 px-4">
        <section className="container mx-auto xl:mt-16 lg:mt-16 md:mt-16 mt-12  rounded-md  gradient">
          <div className="xl:pl-16 xl:pt-12 lg:pl-12 lg:pt-12 md:pt-12 pt-12 md:pl-8 pl-4">
            <h2 class="xl:text-4xl lg:text-4xl md:text-3xl font-bold text-black text-2xl">
              About Junior Toes
            </h2>
            <p className="xl:text-base lg:text-base text-sm md:text-base text-black xl:mr-16 xl:pt-4 lg:mr-12 lg:pt-4 md:mr-12 md:pt-4 pt-2">
              Junior's Toes Preschool is an educational institution focused on
              providing a nurturing and stimulating environment for young
              children during their foundational years. The preschool emphasizes
              a holistic approach to early childhood education, integrating
              play-based learning, creative activities, and foundational
              academics to support the cognitive, emotional, and physical
              development of children.
            </p>
            <div className="flex gap-4 xl:mt-4 lg:mt-4 md:mt-4 mt-4">
              <button class="borderpeach  text-blue rounded xl:px-8 px-2 xl:py-3 py-1 md:py-2 lg:py-3 md:py-3 lg:px-8 md:px-8   transition">
                <a href="/enroll-now">Admission</a>
              </button>
              <button
                class="text-white rounded xl:px-8 px-2 xl:py-3 py-1 md:py-2 lg:py-3 md:py-3 lg:px-8 md:px-8"
                style={{ background: "#0189A5" }}
              >
                <a href="/become-partner">Become A Partner</a>
              </button>
            </div>
          </div>
          <div className="flex justify-end xl:-mt-16 lg:-mt-16">
            <img
              className="xl:w-3/12 lg:w-4/12 md:w-40 w-40"
              src={bannerr}
              alt=""
            />
          </div>
        </section>
      </div>

      <section className="bg-lightsky  xl:mt-16 lg:mt-16 lg:pb-16 xl:pb-16 md:mt-12 md:pb-16 pt-14 pb-12 xl:block lg:block md:block sm:hidden hidden">
        <div className="container mx-auto  ">
          <div className="text-center ">
            <h2 class="text-peach xl:text-xl lg:text-xl text-xl text-red-600 font-semibold   bubblegum ">
              OUR SCHOOL
            </h2>
            <h1 class="xl:text-4xl lg:text-4xl md:text-3xl text-2xl pt-2  font-bold text-black xl:pt-2">
              Leadership Team
            </h1>
            <p class="text-black xl:text-lg xl:pt-2 xl:w-6/12 lg:text-lg lg:pt-2 lg:w-6/12 justify-center text-center mx-auto md:w-6/12 md:text-base text-sm xl:px-0 lg:px-0 md:px-0 px-4">
              Founded By National and International Award Winning Educationists
              and Curriculum Experts
            </p>
          </div>

          <div className="flex xl:pt-8 lg:pt-12 items-center xl:gap-0 lg:gap-4 xl:px-0 lg:px-4 md:pt-12 ">
            <div className="xl:w-4/12 lg:w-4/12 md:w-4/12 gap-4 xl:pt-0 lg:pt-0 pt-8">
              <div>
                <div className="">
                  <div className="xl:mt-4 lg:mt-4 md:mt-4">
                    <img
                      src={sunitha}
                      alt="Children Learning"
                      class="rounded-lg xl:w-8/12 lg:w-8/12 md:w-8/12 justify-center mx-auto "
                    />
                  </div>
                  <div className="xl:mt-6 lg:mt-6 md:mt-6">
                    <h2 className="xl:text-xl lg:text-xl text-xl font-bold text-black text-center">
                      Sunitha Gowda
                    </h2>
                    <p className="xl:text-base lg:text-base text-base uppercase text-blue font-semibold text-center xl:pt-1">
                      Founder & Managing Director junior toes
                    </p>
                    <a href="/leadership-teams">
                      <p className="text-center xl:mt-2 xl:pb-3 text-gray-500 font-semibold">
                        View More <i className="las la-angle-double-right"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </div>

              <div>
                <div className="">
                  <div className="xl:mt-4 lg:mt-4 mt-4">
                    <img
                      src={stella}
                      alt="Children Learning"
                      class="rounded-lg xl:w-8/12 lg:w-8/12 md:w-8/12 justify-center mx-auto "
                    />
                  </div>
                  <div className="xl:mt-6 lg:mt-4 mt-4">
                    <h2 className="xl:text-xl lg:text-xl text-xl font-bold text-black text-center">
                    Dr. Stella Pandhare
                    </h2>
                    <p className="xl:text-base lg:text-base text-base text-blue font-semibold text-center xl:pt-1 uppercase">
                    Chief Academic Advisor
                    </p>
                    <a href="/leadership-teams">
                      <p className="text-center xl:mt-2 xl:pb-3 text-gray-500 font-semibold">
                        View More <i className="las la-angle-double-right"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="xl:w-4/12 lg:w-4/12 md:w-4/12">
              <div className="xl:mt-4 lg:mt-4 mt-4">
                <img
                  src={ashwiniimg}
                  alt="Children Learning"
                  class="rounded-lg"
                />
              </div>
              <div className="xl:mt-6 lg:mt-6 md:mt-6">
                <h2 className="xl:text-xl lg:text-xl text-xl font-bold text-black text-center">
                  Ashwini Puneeth Raj Kumar
                </h2>
                <p className="xl:text-base lg:text-base text-base pt-2 text-blue font-semibold text-center xl:pt-2">
                  CO-FOUNDER & DIRECTOR, JUNIOR TOES
                </p>
                <a href="/leadership-teams">
                  <p className="text-center xl:mt-2 xl:pb-3 text-gray-500 font-semibold">
                    View More <i className="las la-angle-double-right"></i>
                  </p>
                </a>
              </div>
            </div>

            <div className="xl:w-4/12 lg:w-4/12 md:w-4/12 justify-center mx-auto text-center">
              <div>
                <div className="justify-center mx-auto text-center">
                  <div className="xl:mt-4 lg:mt-0 mt-0 ">
                    <img
                      src={spoorthiblack}
                      alt="Children Learning"
                      class="rounded-lg xl:w-8/12  lg:w-8/12 md:w-8/12 justify-center mx-auto "
                    />
                  </div>
                  <div className="xl:mt-6 lg:mt-4 mt-4">
                    <h2 className="xl:text-xl lg:text-xl text-xl font-bold text-black text-center">
                      Spoorthi Vishwas
                    </h2>
                    <p className="xl:text-base lg:text-base text-base text-blue font-semibold text-center xl:pt-1">
                      CO-FOUNDER & CEO, JUNIOR TOES
                    </p>
                    <a href="/leadership-teams">
                      <p className="text-center xl:mt-2 xl:pb-3 text-gray-500 font-semibold">
                        View More <i className="las la-angle-double-right"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </div>
              <div className="">
                <div className="justify-center mx-auto text-center">
                  <div className="xl:mt-4 lg:mt-4 mt-4">
                    <img
                      src={shruthiblack}
                      alt="Children Learning"
                      class="rounded-lg xl:w-8/12 lg:w-8/12  md:w-8/12 justify-center mx-auto "
                    />
                  </div>
                  <div className="xl:mt-6 lg:mt-6 md:mt-6">
                    <h2 className="xl:text-xl font-bold text-black text-center">
                      Shruthi Kiran
                    </h2>
                    <p className="xl:text-base lg:text-base text-base text-blue font-semibold text-center uppercase xl:pt-1">
                      Director– Junior Toes
                    </p>
                    <a href="/leadership-teams">
                      <p className="text-center xl:mt-2 xl:pb-3 text-gray-500 font-semibold">
                        View More <i className="las la-angle-double-right"></i>
                      </p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* leaders mobile view */}
      <section className="xl:hidden lg:hidden md:hidden sm:block block bg-lightsky pb-12 mt-12">
        <h1 class=" text-2xl pt-12  font-bold text-black text-center">
          Leadership Team
        </h1>
        <p class="text-black justify-center text-center mx-auto  text-sm xl:px-0 lg:px-0 md:px-0 px-4">
          Founded By National and International Award Winning Educationists and
          Curriculum Experts
        </p>
        <div className="px-4">
          <div className="">
            <div className="mt-6">
              <img
                src={ashwiniimg}
                alt="Children Learning"
                class="rounded-lg w-12/12 justify-center mx-auto "
              />
            </div>
            <div className="mt-4">
              <h2 className=" text-xl font-bold text-black text-center">
                Ashwini Puneeth Raj Kumar
              </h2>
              <p className=" text-base text-blue font-semibold text-center pt-2">
                CO-FOUNDER & DIRECTOR, JUNIOR TOES
              </p>
              <a href="/leadership-teams">
                <p className="text-center mt-2 pb-3 text-gray-500 font-semibold">
                  View More <i className="las la-angle-double-right"></i>
                </p>
              </a>
            </div>
          </div>

          <div className="">
            <div className="mt-6">
              <img
                src={sunitha}
                alt="Children Learning"
                class="rounded-lg w-12/12 justify-center mx-auto "
              />
            </div>
            <div className="mt-4">
              <h2 className=" text-xl font-bold text-black text-center">
                Sunitha Gowda
              </h2>
              <p className=" text-base text-blue font-semibold text-center pt-2 uppercase">
                Founder & Managing Director JUNIOR TOES
              </p>
              <a href="/leadership-teams">
                <p className="text-center mt-2 pb-3 text-gray-500 font-semibold">
                  View More <i className="las la-angle-double-right"></i>
                </p>
              </a>
            </div>
          </div>

          <div className="">
            <div className="mt-6">
              <img
                src={spoorthiblack}
                alt="Children Learning"
                class="rounded-lg w-12/12 justify-center mx-auto "
              />
            </div>
            <div className="mt-4">
              <h2 className=" text-xl font-bold text-black text-center">
                Spoorthi Vishwas
              </h2>
              <p className=" text-base text-blue font-semibold text-center pt-2">
                CO-FOUNDER & CEO, JUNIOR TOES
              </p>
              <a href="/leadership-teams">
                <p className="text-center mt-2 pb-3 text-gray-500 font-semibold">
                  View More <i className="las la-angle-double-right"></i>
                </p>
              </a>
            </div>
          </div>

          <div className="">
            <div className="mt-6">
              <img
                src={stella}
                alt="Children Learning"
                class="rounded-lg w-12/12 justify-center mx-auto "
              />
            </div>
            <div className="mt-4">
              <h2 className=" text-xl font-bold text-black text-center">
              Dr. Stella Pandhare
              </h2>
              <p className=" text-base text-blue font-semibold text-center pt-2">
              Chief Academic Advisor
              </p>
              <a href="/leadership-teams">
                <p className="text-center mt-2 pb-3 text-gray-500 font-semibold">
                  View More <i className="las la-angle-double-right"></i>
                </p>
              </a>
            </div>
          </div>

          <div className="">
            <div className="mt-6">
              <img
                src={shruthiblack}
                alt="Children Learning"
                class="rounded-lg w-12/12 justify-center mx-auto "
              />
            </div>
            <div className="mt-4">
              <h2 className=" text-xl font-bold text-black text-center">
                Shruthi Kiran
              </h2>
              <p className=" text-base text-blue font-semibold text-center pt-2">
                Director– Junior Toes
              </p>
              <a href="/leadership-teams">
                <p className="text-center mt-2 pb-3 text-gray-500 font-semibold">
                  View More <i className="las la-angle-double-right"></i>
                </p>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer2 />
    </section>
  );
}
